import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import useWindowSize from 'utils/hooks/useWindowSize';
import styles from 'sections/Benefits/MemberDirectory/components/SectionArticles/SectionArticles.module.scss';

const cn = classNames.bind(styles);

const SectionArticles = (): ReactElement => {
  const { width: screenWidth } = useWindowSize();

  const getImagePathByScreenWidth = (imageName: string) => {
    if (screenWidth >= 1025) {
      return `/images/pages/Benefits/MemberDirectory/${imageName}-desktop.webp`;
    } else if (screenWidth >= 576) {
      return `/images/pages/Benefits/MemberDirectory/${imageName}-tablet.webp`;
    } else if (screenWidth >= 375) {
      return `/images/pages/Benefits/MemberDirectory/${imageName}-mobile.webp`;
    } else {
      return `/images/pages/Benefits/MemberDirectory/${imageName}-desktop.webp`;
    }
  };

  const renderTitleByScreenWidth = () => {
    if (screenWidth >= 1025) {
      return (
        <h2 className={cn('articles__title')}>
          <span>A Streamlined Freight</span>
          <span> Forwarder List Provided by</span>
          <span> DP World</span>
        </h2>
      );
    } else if (screenWidth >= 576) {
      return (
        <h2 className={cn('articles__title')}>
          <span>A Streamlined Freight Forwarder List</span>
          <span> Provided by DP World</span>
        </h2>
      );
    } else {
      return (
        <h2 className={cn('articles__title')}>
          A Streamlined Freight Forwarder List Provided by DP World
        </h2>
      );
    }
  };

  return (
    <section className={cn('articles')}>
      <div className={cn('container')}>

        <div className={cn('articles__article')}>
          <div className={cn('articles__text-content')}>
            {renderTitleByScreenWidth()}
            <p className={cn('articles__paragraph')}>
              Finding the right logistics partner shouldn’t feel like guesswork.
              With the DF Alliance directory, it doesn’t. You can narrow your 
              search by selecting the most important parameters: membership type, 
              regional coverage or type of cargo handled. It's designed for 
              real-world needs, not just categories on a screen.
            </p>
            <p className={cn('articles__paragraph')}>
              What makes this tool stand out is its ability to match users with forwarders
              who’ve been through a vetting process not just names on a list, but professionals
              with proven experience. You’re not left scrolling endlessly. Instead, you land
              on partners who meet the brief, understand the stakes, and are ready to move.
            </p>
          </div>
          <div className={cn('articles__image-box')}>
            <img
              className={cn('articles__image')}
              src={getImagePathByScreenWidth('handshake')}
              alt='article picture'
            />
          </div>
        </div>

        <div className={cn('articles__article')}>
          <div className={cn('articles__image-box')}>
            <img
              className={cn('articles__image')}
              src={getImagePathByScreenWidth('screenshot')}
              alt='article picture'
            />
          </div>
          <div className={cn('articles__text-content')}>
            <h2 className={cn('articles__title')}>
              What Is a Freight Forwarder Directory?
            </h2>
            <p className={cn('articles__paragraph')}>
              Think of it as a logistics Rolodex, but modern, searchable, and built
              for action. A freight forwarder directory pulls together operators from
              across the world those who specialize in land, air, sea, or some combination
              of the three and presents them in one structured platform. Whether you’re a
              small exporter taking your first step into international markets or a
              supply chain lead juggling multi-region shipments, this tool helps you
              find the right fit fast.
            </p>
            <p className={cn('articles__paragraph')}>
              It’s not just about access. The directory brings transparency to the table.
              You’ll know where a forwarder operates, what services they offer, how long
              they’ve been in business, and who they’ve worked with. That means fewer
              blind spots and better-informed decisions. In a sector where one weak link
              can disrupt an entire chain, that kind of clarity is no small advantage.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default SectionArticles;